import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = n => (_pushScopeId("data-v-a7a92418"), n = n(), _popScopeId(), n);
var _hoisted_1 = {
  class: "tw-mb-5px"
};
var _hoisted_2 = {
  class: "tw-flex"
};
var _hoisted_3 = ["href"];
var _hoisted_4 = ["src"];
var _hoisted_5 = ["href"];
var _hoisted_6 = ["src"];
var _hoisted_7 = ["href"];
var _hoisted_8 = ["src"];
var _hoisted_9 = ["href"];
var _hoisted_10 = {
  class: "tw-size-[34px] tw-rounded-full tw-bg-w-primary tw-flex tw-items-center tw-justify-center tw-mr-20px"
};
var _hoisted_11 = ["src"];
var _hoisted_12 = {
  class: "tw-flex tw-items-center"
};
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = {
  class: "tw-flex tw-flex-col tw-justify-between tw-items-center tw-flex-wrap sm:tw-flex-nowrap"
};
var _hoisted_15 = ["innerHTML"];
var _hoisted_16 = ["innerHTML"];
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
import { ref, computed, onBeforeMount, onBeforeUnmount } from "vue";
import { useMetadataStore } from "@wkWebSrc/js/store";
export default /*#__PURE__*/_defineComponent({
  __name: 'ShareModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    icons: {},
    labels: {},
    shareModalData: {},
    gaEvent: {}
  },
  emits: ["closedModal"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var mdStore = useMetadataStore();
    /**
     * Precondition:
     * - This modal has to be used iff there is no default mechanism in the device the application is running
     * - This behaviour is intentional since this component will simply open a share modal, it won't handle the case in which there is another share mechanism
     * */
    var props = __props;
    var emits = __emit;
    var show = ref(false);
    var success = ref(null);
    var telegram = computed(() => {
      return "https://t.me/share/url?url=".concat(encodeURIComponent(props.shareModalData.url + "&utm_medium=telegram"), "&text=").concat(encodeURIComponent(props.shareModalData.title || ""));
    });
    var whatsapp = computed(() => {
      return "https://api.whatsapp.com/send?text=".concat(encodeURIComponent(props.shareModalData.title + "\n" + props.shareModalData.url + "&utm_medium=whatsapp"));
    });
    var facebook = computed(() => {
      return "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(props.shareModalData.url + "&utm_medium=facebook"));
    });
    var email = computed(() => {
      // eslint-disable-next-line max-len
      return "mailto:?subject=".concat(props.shareModalData.title, "&body=").concat(encodeURIComponent(props.shareModalData.title + "\n\n" + props.shareModalData.url + "&utm_medium=email"));
    });
    onBeforeMount(() => {
      show.value = props.showModal;
      mdStore.setLocation("Modale Condivisione");
    });
    onBeforeUnmount(() => {
      mdStore.setLocation("");
    });
    var handleShareBtt = type => __awaiter(this, void 0, void 0, function* () {
      var {
        url,
        title
      } = props.shareModalData;
      if (!title) title = "";
      //Sending GA Event
      if (props.gaEvent) sendGAEvent(props.gaEvent, {
        event_location: "".concat(props.shareModalData.location, " - ").concat(mdStore.location),
        social: type
      });
      switch (type) {
        case "telegram":
          url = "https://t.me/share/url?url=".concat(encodeURIComponent(url + "&utm_medium=telegram"), "&text=").concat(encodeURIComponent(title));
          break;
        case "whatsapp":
          url = "https://api.whatsapp.com/send?text=".concat(encodeURIComponent(title + "\n" + url + "&utm_medium=whatsapp"));
          break;
        case "facebook":
          url = "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(url + "&utm_medium=facebook"));
          break;
        case "email":
          window.location.href = "mailto:?subject=".concat(title, "&body=").concat(encodeURIComponent(title + "\n\n" + url + "&utm_medium=email"));
          return;
        default:
          break;
      }
      window.open(url, "_blank", "location=yes,height=350,width=600,scrollbars=yes,status=yes");
    });
    var handleCopyText = () => {
      try {
        navigator.clipboard.writeText(props.shareModalData.url);
        success.value = true;
      } catch (err) {
        console.error(err);
        success.value = false;
      } finally {
        //Removing the status text
        setTimeout(() => {
          success.value = null;
        }, 5000);
      }
    };
    var closedModal = () => {
      emits("closedModal");
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(BaseBtModal, {
        id: "share-modal",
        modelValue: show.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => show.value = $event),
        "data-cy": "share-modal",
        "show-modal": show.value,
        "custom-modal-dialog-classes": "modal-lg",
        "custom-modal-body-classes": "tw-py-15px",
        "header-title": _ctx.labels.share_ad,
        onClosed: closedModal
      }, {
        body: _withCtx(() => [_createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.labels.share_on_social), 1 /* TEXT */), _createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
          id: "facebook-share",
          "data-cy": "facebook-share-btn",
          class: "tw-flex tw-items-center tw-py-10px",
          href: facebook.value,
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleShareBtt('facebook'), ["stop", "prevent"]))
        }, [_createElementVNode("img", {
          height: "40",
          width: "40",
          src: _ctx.icons.fb_rounded,
          class: "share-social-icon tw-mr-20px",
          alt: "Icona Facebook"
        }, null, 8 /* PROPS */, _hoisted_4)], 8 /* PROPS */, _hoisted_3), _createElementVNode("a", {
          id: "whatsapp-share",
          "data-cy": "whatsapp-share-btn",
          class: "tw-flex tw-items-center tw-py-10px",
          href: whatsapp.value,
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => handleShareBtt('whatsapp'), ["stop", "prevent"]))
        }, [_createElementVNode("img", {
          height: "40",
          width: "40",
          src: _ctx.icons.whatsapp_rounded,
          class: "share-social-icon tw-mr-20px",
          alt: "Icona WhatsApp"
        }, null, 8 /* PROPS */, _hoisted_6)], 8 /* PROPS */, _hoisted_5), _createElementVNode("a", {
          id: "telegram-share",
          "data-cy": "telegram-share-btn",
          class: "tw-flex tw-items-center tw-py-10px",
          href: telegram.value,
          onClick: _cache[2] || (_cache[2] = _withModifiers($event => handleShareBtt('telegram'), ["stop", "prevent"]))
        }, [_createElementVNode("img", {
          height: "40",
          width: "40",
          src: _ctx.icons.telegram_rounded,
          class: "share-social-icon tw-mr-20px",
          alt: "Icona Telegram"
        }, null, 8 /* PROPS */, _hoisted_8)], 8 /* PROPS */, _hoisted_7), _createElementVNode("a", {
          "data-cy": "email-share-btn",
          class: "tw-flex tw-items-center tw-py-10px",
          href: email.value,
          onClick: _cache[3] || (_cache[3] = _withModifiers($event => handleShareBtt('email'), ["prevent", "stop"]))
        }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
          width: "28",
          src: _ctx.icons.mail,
          class: "share-social-icon",
          alt: "Icona Email"
        }, null, 8 /* PROPS */, _hoisted_11)])], 8 /* PROPS */, _hoisted_9)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", {
          class: "tw-mb-5px",
          innerHTML: _ctx.labels.generic_or
        }, null, 8 /* PROPS */, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_createVNode(BaseInput, {
          class: "tw-mr-0 sm:tw-mr-10px",
          type: "text",
          size: "45",
          disabled: "",
          "model-value": _ctx.shareModalData.url
        }, null, 8 /* PROPS */, ["model-value"]), _createVNode(BaseButton, {
          class: "tw-btn-w-primary tw-relative tw-mt-10px",
          onClick: _withModifiers(handleCopyText, ["stop"])
        }, {
          default: _withCtx(() => [_createElementVNode("span", {
            innerHTML: _ctx.labels.generic_copy
          }, null, 8 /* PROPS */, _hoisted_15), success.value !== null ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "-gray popup-copied-link tw-w-full tw-absolute tw-text-10",
            innerHTML: success.value ? _ctx.labels.copied_link : _ctx.labels.copied_error
          }, null, 8 /* PROPS */, _hoisted_16)) : _createCommentVNode("v-if", true)]),
          _: 1 /* STABLE */
        })])]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue", "show-modal", "header-title"]);
    };
  }
});